export default __webpack_public_path__ + "static/media/Arquivo XML.05faf296.svg";